<template>
  <v-theme-provider light>
    <div class="visio-sidebar">
      <v-card-title class="sidebar-title">
        <v-btn
          v-if="subcomponent"
          class="mr-1"
          small
          text
          fab
          @click="initialize"
          ><v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="black--text">{{ title }}</span>
        <v-btn
          small
          text
          fab
          @click="close"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="sidebar-content">
        <component
          v-if="value"
          :is="sidebar"
          v-model="subcomponent"
          :inspection="inspection"
        ></component>
      </v-card-text>
    </div>
  </v-theme-provider>
</template>

<script>
import { capitalize } from "lodash"
import SideBarActivities from "./SideBarActivities.vue"
import SideBarChat from "./SideBarChat.vue"
import SideBarParticipants from "./SideBarParticipants.vue"
export default {
  name: "SideBar",
  components: {
    SideBarActivities,
    SideBarChat,
    SideBarParticipants
  },
  data() {
    return {
      subcomponent: null
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    inspection: {
      type: Object,
      required: true
    }
  },
  computed: {
    sidebar() {
      return `SideBar${capitalize(this.value)}`
    },
    title() {
      const title = this.subcomponent?.title || this.value
      return capitalize(title)
    }
  },
  methods: {
    close() {
      this.initialize()
      this.$emit("input", null)
    },
    initialize() {
      this.subcomponent = null
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.initialize()
    }
  }
}
</script>

<style lang="scss">
.visio-sidebar {
  border: 1px solid black;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  height: 100%;
  max-height: 100%;
  width: 300px;
  min-width: 200px;

  .sidebar-title {
    flex: 0 1 auto;
    justify-content: space-between;
  }
  .sidebar-content {
    flex: 1 1 auto;
    overflow: hidden;
  }
}
</style>
